/** Valid persisted values are `advance` and `reset`. Legacy `continue` means advance. */
export function normalizeFailAction(value) {
  return value === 'reset' ? 'reset' : 'advance'
}
